import React from "react";
import { clients } from "../data/mock";

const Clients = () => {
  const loop = [...clients, ...clients];
  return (
    <section className="py-16 md:py-24 border-t border-[#d8d5cc] overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 mb-10">
        <p className="text-[11px] tracking-[0.18em] uppercase text-[#6b6b64]">
          Trusted by / 04
        </p>
      </div>
      <div className="relative marquee">
        <div className="flex gap-14 md:gap-20 items-center whitespace-nowrap marquee-track">
          {loop.map((c, i) => (
            <span
              key={`${c}-${i}`}
              className="font-display text-[28px] md:text-[44px] tracking-[-0.02em] text-[#0d0d0d] flex items-center gap-14 md:gap-20"
            >
              {c}
              <span className="w-1.5 h-1.5 rounded-full bg-[#0d0d0d] inline-block" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;
